import { createRouter, createWebHistory } from "@ionic/vue-router";
import { RouteRecordRaw } from "vue-router";
import {savePreferences, getPreferences, getMinRequiredDataForAppLoad} from "@/storage/DataStorage";
import {store} from "@/store";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/calculator",
        name: "calculator",
        component: () => import("@/views/Calculator/CalculatorMain.vue"),
    },
    {
        path: "/fields",
        name: "fields",
        component: () => import("@/views/Fields.vue"),
    },
    {
        path: "/privacy",
        name: "privacy",
        component: () => import("@/views/PrivacyPage.vue"),
    },
    {
        path: "/coach",
        name: "coach",
        component: () => import("@/views/Coach.vue"),
    },
    {
        path: "/fields/:fieldId/learn-more",
        name: "learn-more",
        component: () => import("@/views/JourneySets.vue"),
    },
    {
        path: "/fields/:fieldId/more-topics",
        name: "more-topics",
        component: () => import("@/views/JourneySets.vue"),
    },
    {
        path: "/fields/:fieldId/journey-sets",
        name: "journey-sets",
        component: () => import("@/views/JourneySets.vue"),
    },
    {
        path: "/fields/:fieldId/journey-sets/:journeySetId/journeys",
        name: "journeys",
        component: () => import("@/views/JourneyList.vue"),
    },
    {
        path: "/fields/:fieldId/journey-sets/:journeySetId/journey/:journeyId",
        name: "journey",
        component: () => import("@/views/Journey/JourneyPage.vue"),
    },
    {
        path: "/security",
        name: "security",
        component: () => import("@/views/SecurityPage.vue"),
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach(async (nextRoute) => {
    try {
        console.log('[router.beforeEach] START', nextRoute.fullPath);
        let preferences = store.getters.getPreferences();
        const isFirstTimeOpeningApp = store.getters.isFirstTimeOpeningApp();
        const needToSetPin = store.getters.getNeedToSetPin();
        console.log('[router.beforeEach] isFirstTimeOpeningApp=', isFirstTimeOpeningApp, 'needToSetPin=', needToSetPin);
        if (needToSetPin) {
            return false;
        }
        

        //Apps that use the calc or pin screen on startup redirect to '/calc' after '/'
        //but we only want to run this once
        if (isFirstTimeOpeningApp && nextRoute.fullPath === '/') {
            console.log('[router.beforeEach] calling getMinRequiredDataForAppLoad()');
            await getMinRequiredDataForAppLoad();
            console.log('[router.beforeEach] getMinRequiredDataForAppLoad() done');
        } else {
            console.log('[router.beforeEach] calling getPreferences()');
            preferences = await getPreferences();
            console.log('[router.beforeEach] getPreferences() done');
            await store.dispatch("setPreferences", preferences);
        }
        
        if (!["/", "/calculator"].includes(nextRoute.fullPath)) {
            preferences.lastVisitedRoute = nextRoute.fullPath;
            //savePreferences() takes care of this, but we do this here because
            //we don't want to have to wait on the indexedDB on initial app load
            await store.dispatch("setPreferences", preferences);
            savePreferences(preferences);
        } else if (preferences.shouldSetPin) {
            return true;
        } else if (!preferences.shouldUseSafetyCalculator) {
            return { path: preferences.lastVisitedRoute};
        }
        console.log('[router.beforeEach] END ok');
    } catch (err) {
        console.error('[router.beforeEach] CAUGHT', err);
        if (err instanceof Error) {
            console.error('[router.beforeEach] message=', err.message, 'name=', err.name, 'stack=', err.stack);
        }
        if (err && typeof (err as any).name === 'string') console.error('[router.beforeEach] err.name=', (err as any).name);
        if (err && typeof (err as any).code !== 'undefined') console.error('[router.beforeEach] err.code=', (err as any).code);
        return false;
    }
});

router.afterEach(async (to,from) => {
    if(from.fullPath === '/fields'){ 
        await store.dispatch('clearRouteHistory', from.fullPath);  
        store.dispatch('addRouteHistory', from.fullPath);
    }else{
        if(store.getters.getLastVisitedRoute() !== from.fullPath){
            await store.dispatch('addRouteHistory', from.fullPath);
        }else{
            await store.dispatch('popRouteHistory', from.fullPath);
        }
    }
});


export default router;
